import {createDisplayFnFactory} from '../displayValueFactory';
import {type LinePlotDisplayFnArgs} from '../types';
import {type LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

/**
 * Configured factory for creating display functions for line plot settings.
 * Consolidates boolean, number, and enum display function creation.
 */
export const createDisplayFn = createDisplayFnFactory<
  LinePlotTemplateSettings,
  LinePlotDisplayFnArgs
>(
  args => args.currTemplateLinePlotSettings,
  args => args.currWorkspaceLinePlotSettings
);

// Legacy aliases for backward compatibility
export const createBooleanDisplayFn = createDisplayFn;
export const createNumberDisplayFn = createDisplayFn;
export const createEnumDisplayFn = createDisplayFn;
